import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background: white;
  box-shadow: 0px 5px 10px rgba(0, 35, 75, 0.15);
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  gap: 16px;
  flex-wrap: wrap;
  @media(max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding-top: 16px;
  }
  @media(max-width: 480px) {
    gap: 12px;
    padding-top: 12px;
  }
`

export const ProfileImage = styled.img`
  width: 96px;
  min-height: 96px;
  align-self: stretch;
  object-fit: cover;
  @media(max-width: 768px) {
    width: 80px;
    min-height: 80px;
    align-self: center;
  }
  @media(max-width: 480px) {
    width: 64px;
    min-height: 64px;
  }
`

export const ContentWrapper = styled.div`
  flex: 1 1 0;
  padding: 16px 24px 16px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media(max-width: 768px) {
    width: 100%;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  @media(max-width: 480px) {
    padding: 12px;
  }
`

export const LeftSection = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  @media(max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  @media(max-width: 480px) {
    gap: 12px;
  }
`

export const ProfileInfo = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  @media(max-width: 768px) {
    align-items: center;
  }
`

export const NameRow = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  @media(max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`

export const Name = styled.div`
  color: #00234B;
  font-size: 22px;
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  word-wrap: break-word;
  @media(max-width: 768px) {
    font-size: 20px;
  }
  @media(max-width: 480px) {
    font-size: 18px;
  }
`

export const Badge = styled.div`
  padding: 5px 11px;
  background: #7F91A5;
  box-shadow: 0px 5px 10px rgba(127, 145, 165, 0.15);
  overflow: hidden;
  border-radius: 11px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  color: white;
  font-size: 10px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
  word-wrap: break-word;
  @media(max-width: 480px) {
    font-size: 9px;
    padding: 4px 8px;
    border-radius: 8px;
  }
`

export const Details = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  @media(max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`

export const DetailItem = styled.div`
  color: ${props => props.primary ? '#0082CE' : 'rgba(0, 35, 75, 0.50)'};
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  line-height: 22px;
  word-wrap: break-word;
  @media(max-width: 480px) {
    font-size: 11px;
    line-height: 18px;
  }
`

export const SectionName = styled(DetailItem).attrs({ primary: true })``

export const FacilityName = styled(DetailItem)``

export const MemberId = styled(DetailItem)``

export const EditLink = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  @media(max-width: 768px) {
    align-self: center;
  }
`

export const EditText = styled.div`
  width: 92px;
  color: #0082CE;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  line-height: 18px;
  word-wrap: break-word;
`
